(function () {
  function openLightbox(lightbox, src) {
    const img = lightbox.querySelector(".mc-lightbox__img");
    img.src = src;
    lightbox.hidden = false;
    document.documentElement.style.overflow = "hidden";
  }

  function closeLightbox(lightbox) {
    const img = lightbox.querySelector(".mc-lightbox__img");
    img.src = "";
    lightbox.hidden = true;
    document.documentElement.style.overflow = "";
  }

  document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".js-mc-lightbox-trigger");
    if (trigger) {
      e.preventDefault();

      // find the correct lightbox for THIS section
      const sectionRoot = trigger.closest(".shopify-section") || document;
      const lightbox = sectionRoot.querySelector(".mc-lightbox");
      if (!lightbox) return;

      const src = trigger.getAttribute("data-mc-lightbox-src") || trigger.getAttribute("href");
      openLightbox(lightbox, src);
      return;
    }

    if (e.target.closest("[data-mc-lightbox-close]")) {
      const lightbox = e.target.closest(".mc-lightbox");
      if (lightbox) closeLightbox(lightbox);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    document.querySelectorAll(".mc-lightbox:not([hidden])").forEach(closeLightbox);
  });
})();